import script from "./ModalProyectosPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalProyectosPedido.vue?vue&type=script&setup=true&lang=js"

import "./ModalProyectosPedido.vue?vue&type=style&index=0&id=4cc73b22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc73b22"]])

export default __exports__